module.exports = __webpack_public_path__ + "static/media/strengthen-small.5d541aba.svg";